import * as action from "../reducers/linkReducer";
import axios, { authHeader } from "../../services/HTTPService";
const API_URL = process.env.REACT_APP_API_URL;

export const fetchAll = async (
  dispatch,
  {
    fieldTofilter,
    filter,
    fieldToSort,
    sortDirection,
    page,
    pageSize,
    member,
    bulk
  } = {
    fieldTofilter: "name",
    filter: "",
    fieldToSort: "id",
    sortDirection: "asc",
    page: 1,
    pageSize: 8,
    bulk: null,
  }
) => {
  dispatch(action.setListLoading(true));
  dispatch(action.setLinkList([]));

  return axios
    .get(API_URL + `/api/quick-access-links/backoffice/search`, {
      headers: authHeader(),
      params: {
        fieldTofilter,
        filter,
        fieldToSort,
        sortDirection,
        page,
        pageSize,
        member,
        bulk
      },
    })
    .then(({ data }) => {
      const meta = data?.meta;
      dispatch(action.setLinkList({ data }));
      dispatch(action.setMetadata({ meta }));
      dispatch(action.setListLoading(false));
    })
    .catch((error) => {
      dispatch(
        action.setLinkError({ error: error?.response?.data?.error?.message })
      );
      dispatch(action.setListLoading(false));
    });
};

export const fetchDetails = async (dispatch, id) => {
  return axios
    .get(API_URL + `/api/quick-access-links/${id}?source=backoffice`, { headers: authHeader() })
    .then(({ data }) => {
      dispatch(action.setLinkDetail({ data }));
    })
    .catch((error) => {
      dispatch(
        action.setLinkError({ error: error?.response?.data?.error?.message })
      );
    });
};

export const create = async (dispatch, body) => {
  return axios
    .post(API_URL + "/api/quick-access-links", body, { headers: authHeader() })
    .then(({ data }) => {
      dispatch(action.setLink({ data }));
    })
    .catch((error) => {
      dispatch(
        action.setLinkError({ error: error?.response?.data?.error?.message })
      );
    });
};

export const update = async (dispatch, id, body) => {
  return axios
    .put(API_URL + `/api/quick-access-links/${id}`, body, {
      headers: authHeader(),
    })
    .then(({ data }) => {
      dispatch(action.setLink({ data }));
      return { success: true, data };
    })
    .catch((error) => {
      dispatch(
        action.setLinkError({ error: error?.response?.data?.error?.message })
      );
      throw error; // Re-throw the error so it can be caught in components
    });
};

export const remove = async (dispatch, id, params) => {
  return axios
    .delete(API_URL + `/api/quick-access-links/${id}`, {
      headers: authHeader(),
    })
    .then(async () => {
      await fetchAll(dispatch, params);
    })
    .catch((error) => {
      dispatch(
        action.setLinkError({ error: error?.response?.data?.error?.message })
      );
    });
};
